import React, { useContext } from "react";
import { Button, Dialog } from "iuvity-ui-components";
import { AppContext } from "../../context";
import { Tag } from "iuvity-ui-components/dist/tag";
import infoApp from "../../assets/info-application.png";


interface InformationApplicationProps {
  visible: boolean;
  closeHandler: Function;
}


export const InformationApplication: React.FC<InformationApplicationProps> = ({
  visible,
  closeHandler
}) => {
  const {
    t
  } = useContext(AppContext);

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          label={t("Applications.understandLabel")}
          onClick={() => closeHandler()}
          className="mr-4"
          variant="p-button"
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1"
      className="dialog-form"
      header={<>{t("Applications.helpChannelApplicationTitle")} <Tag  style={{ color:'#333333'}}value={t('Applications.ObjectiveApplicationLabel')} /></>}
      visible={visible}
      onHide={() => closeHandler()}
      style={{ width: "45rem", height: 'auto' }}
      footer={renderFooter}
      draggable={false}
    >
      <p id="HelpAppNameText" className="pb-3">
        {t('Applications.newApplicationDescription')}
      </p>
      <center>

        <img
          src={infoApp}
          alt="IuviBANKING"
          width={'75%'}
        />
      </center>

    </Dialog>
  );
};
